import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body pt-0" }
const _hoisted_3 = { class: "table-responsive" }
const _hoisted_4 = { class: "table" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = { class: "fw-bold text-nowrap" }
const _hoisted_8 = { class: "d-flex text-nowrap mx-4 d-sm-none" }
const _hoisted_9 = { class: "" }
const _hoisted_10 = { class: "d-flex text-nowrap" }
const _hoisted_11 = { class: "me-1" }
const _hoisted_12 = { class: "flex-fill me-1" }
const _hoisted_13 = { class: "me-1" }
const _hoisted_14 = { class: "flex-fill text-truncate" }
const _hoisted_15 = { class: "text-end d-none d-sm-table-cell" }
const _hoisted_16 = { class: "d-flex text-nowrap me-2" }
const _hoisted_17 = { class: "align-middle d-none d-sm-table-cell" }
const _hoisted_18 = { class: "mx-2" }
const _hoisted_19 = { class: "text-center flex-fill text-truncate" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_rank_icon = _resolveComponent("rank-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "card-header" }, [
        _createElementVNode("span", { class: "h5" }, [
          _createElementVNode("i", {
            class: "fas fa-money-check-alt fa-fw me-1",
            "aria-hidden": "true"
          }),
          _createTextVNode(" Bonos #GTRLife ")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("table", _hoisted_4, [
            _cache[3] || (_cache[3] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", { class: "text-center col-5 col-sm-2" }, [
                  _createElementVNode("div", { class: "pb-0 pb-sm-2" }, "Periodo"),
                  _createElementVNode("div", { class: "pt-0 d-sm-none" }, "Monto")
                ]),
                _createElementVNode("th", { class: "text-center col-7 col-sm-4" }, [
                  _createElementVNode("div", { class: "pb-0 pb-sm-2" }, "Bono"),
                  _createElementVNode("div", { class: "pt-0 d-sm-none" }, "Estatus")
                ]),
                _createElementVNode("th", { class: "text-center d-none d-sm-table-cell col-sm-3" }, [
                  _createElementVNode("div", null, "Monto")
                ]),
                _createElementVNode("th", { class: "text-center d-none d-sm-table-cell col-sm-3" }, [
                  _createElementVNode("div", null, "Estatus")
                ])
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (!_ctx.bonusList || _ctx.bonusList.length == 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_5, [...(_cache[0] || (_cache[0] = [
                    _createElementVNode("td", {
                      colSpan: "4",
                      class: "text-center"
                    }, [
                      _createTextVNode(" No hay bonos que mostrar"),
                      _createElementVNode("i", { class: "far fa-frown fa-fw ms-1" })
                    ], -1)
                  ]))]))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.bonusList, (b) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: b.id
                    }, [
                      _createElementVNode("td", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, _toDisplayString(b.period), 1),
                        _createElementVNode("div", _hoisted_8, [
                          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "me-1" }, "G$", -1)),
                          _createElementVNode("span", {
                            class: _normalizeClass('flex-fill text-end ' + _ctx.amountClass(b.status))
                          }, _toDisplayString(_ctx.toTwoDecimals(b.amount)), 3)
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("span", _hoisted_11, [
                            (_ctx.typeRankIconClass(b.type))
                              ? (_openBlock(), _createBlock(_component_rank_icon, {
                                  key: 0,
                                  "icon-class": _ctx.typeRankIconClass(b.type),
                                  "extra-class": "fa-fw text-pink"
                                }, null, 8, ["icon-class"]))
                              : (_openBlock(), _createElementBlock("i", {
                                  key: 1,
                                  class: _normalizeClass(_ctx.typeIconClass(b.type))
                                }, null, 2))
                          ]),
                          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.translateType(b.type)), 1)
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass(
                      ' d-sm-none d-flex align-items-center ' +
                      _ctx.statusColorClass(b.status)
                    )
                        }, [
                          _createElementVNode("span", _hoisted_13, [
                            _createElementVNode("i", {
                              class: _normalizeClass('' + _ctx.statusIconClass(b.status)),
                              "aria-hidden": "true"
                            }, null, 2)
                          ]),
                          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.translateStatus(b.status)), 1)
                        ], 2)
                      ]),
                      _createElementVNode("td", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "ms-4 me-1" }, "G$", -1)),
                          _createElementVNode("span", {
                            class: _normalizeClass('flex-fill ' + _ctx.amountClass(b.status))
                          }, _toDisplayString(_ctx.toTwoDecimals(b.amount)), 3)
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_17, [
                        _createElementVNode("div", {
                          class: _normalizeClass(
                      'd-flex align-items-center ' + _ctx.statusColorClass(b.status)
                    )
                        }, [
                          _createElementVNode("span", _hoisted_18, [
                            _createElementVNode("i", {
                              class: _normalizeClass('' + _ctx.statusIconClass(b.status)),
                              "aria-hidden": "true"
                            }, null, 2)
                          ]),
                          _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.translateStatus(b.status)), 1)
                        ], 2)
                      ])
                    ]))
                  }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}